import axios from "../../../../../utils/axiosInceptor";
import { printStatementServices } from "../../../../../configs/constants";

export const leaseStatement = async (leaseId) => {

    try {
        let url = `${printStatementServices}${leaseId}`;
        const result = await axios.get(url);
        if(result?.data?.code === 200){
            return result?.data?.result;
        }
   
    } catch (error) {
        console.log(error, 'leaseStatement');
    }
} 
